<template>
  <v-container class="pa-0"  fluid>
    <component :is="routeItems[activeRoute].component" class=""></component>
  </v-container>
</template>

<script>
import { authRoute } from '@/router/routeRole'
import ObjectArchive from '@/views/archive/objectArchive/ObjectArchive.vue'
import DestroyedObjects from '@/views/archive/destroyedObjects/DestroyedObjects.vue'
import DataDestructionActs from '@/views/archive/dataDestructionActs/DataDestructionActs.vue'
import StatementArchive from "@/views/archive/statementArchive/StatementArchive.vue";
import DataDestructionReports from "@/views/archive/dataDestructionReports/DataDestructionReports.vue";

export default {
  name: 'archiveTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Objektų archyvas',
          route: 'adminObjectArchive',
          component: ObjectArchive,
        },
        {
          title: 'Naikintinų duomenų sąrašas',
          route: 'adminDestroyedObjectsList',
          component: DestroyedObjects,
        },
        {
          title: 'Duomenų naikinimo aktai',
          route: 'adminDataDestructionActs',
          component: DataDestructionActs,
        },
        {
          title: 'Atliktų paieškų sąrašas',
          route: 'adminStatementArchive',
          component: StatementArchive,
        },
        {
          title: 'Paieškų naikinimo ataskaitos',
          route: 'adminDataDestructionReports',
          component: DataDestructionReports,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter((item) => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function (item, index) {
          return this.$route.matched.find((element) => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function (item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
